<template>
  <div class="login-container">
    <div class="bg-decoration bg-circle bg-circle-1"></div>
    <div class="bg-decoration bg-circle bg-circle-2"></div>
    <div class="bg-decoration bg-circle bg-circle-3"></div>
    
    <el-card class="login-card">
      <div class="logo-wrapper">
        <el-icon class="logo-icon"><User /></el-icon>
        <h2 class="logo-title">武侠豪杰数据管理系统</h2>
      </div>

      <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef" label-width="0px" class="login-form">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入账号" :prefix-icon="User" class="form-input" :border="false" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" :prefix-icon="Lock" class="form-input" :border="false" autocomplete="new-password"></el-input>
        </el-form-item>

        <div class="form-footer">
          <el-checkbox v-model="rememberMe" class="remember-checkbox">记住密码</el-checkbox>
          <el-link type="primary" class="forgot-link" @click="handleForgotPassword">忘记密码？</el-link>
        </div>

        <el-form-item>
          <el-button type="primary" @click="handleLogin" class="login-btn" :loading="loginLoading" :disabled="loginLoading">
            <span v-if="!loginLoading">登录</span>
            <span v-else>登录中...</span>
          </el-button>
        </el-form-item>
      </el-form>

      <div class="copyright">© 2025 用户数据管理系统 版权所有</div>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { User, Lock } from '@element-plus/icons-vue'
import axios from 'axios'

const router = useRouter()
const loginFormRef = ref(null)
const loginLoading = ref(false)
const rememberMe = ref(false)

const loginForm = ref({
  username: '',
  password: ''
})

const loginRules = ref({
  username: [
    { required: true, message: '账号不能为空', trigger: 'blur' },
    { min: 3, max: 20, message: '账号长度为3-20个字符', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '密码不能为空', trigger: 'blur' },
    { min: 6, max: 20, message: '密码长度在6-20个字符', trigger: 'blur' }
  ]
})

onMounted(() => {
  const savedUser = localStorage.getItem('savedUser')
  if (savedUser) {
    loginForm.value = JSON.parse(savedUser)
    rememberMe.value = true
  }
})

const handleLogin = async () => {
  if (!loginFormRef.value) return

  try {
    await loginFormRef.value.validate()
    loginLoading.value = true

    const res = await axios({
      url: 'https://log.wuxiahaojie.com/api/Account/login',      //http://192.168.3.177:5058     https://log.wuxiahaojie.com/api
      method: 'post',
      data: {
        Username: loginForm.value.username,
        Password: loginForm.value.password
      },
      headers: { 'Content-Type': 'application/json;charset=utf-8' },
      timeout: 10000,
      validateStatus: status => status >= 200 && status < 500
    })

    if (res.data.code === 200 && res.data.data.token) {
      localStorage.setItem('token', res.data.data.token);

      if (rememberMe.value) {
        localStorage.setItem('savedUser', JSON.stringify(loginForm.value))
      } else {
        localStorage.removeItem('savedUser')
      }

      localStorage.setItem('userInfo', JSON.stringify({
        username: res.data.data.username,
        role: res.data.data.role
      }))

      ElMessage.success('登录成功，正在跳转...')
      setTimeout(() => {
        if(res.data.data.role==='Admin'){
          router.push({
            path: '/phone-verify', 
            query: { phone: res.data.data.username } // 传递手机号到验证页
          })
        }else{
          router.push('/data')
        }
        
      }, 800)
    } else {
      ElMessage.error(res.data.msg || '登录失败')
    }

  } catch (error) {
    let errorMsg = '登录失败'
    if (error.code === 'ERR_CONNECTION_REFUSED') {
      errorMsg = '后端服务未启动或端口错误，请检查后端服务'
    } else if (error.response?.status === 500) {
      errorMsg = '后端服务内部错误，请查看后端日志'
    } else if (error.response?.status === 404) {
      errorMsg = '接口路径错误，后端未找到该接口'
    } else if (error.message === 'Network Error') {
      errorMsg = '网络故障，请检查防火墙/代理软件'
    }

    ElMessage.error(errorMsg)
    console.error('登录错误:', error)
  } finally {
    loginLoading.value = false
  }
}

const handleForgotPassword = () => {
  ElMessageBox.alert(
    '请联系管理员重置密码',
    '忘记密码',
    { confirmButtonText: '确定', type: 'info' }
  )
}
</script>

<style scoped>
.login-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background: linear-gradient(120deg, #4361ee 0%, #3a0ca3 100%);
  overflow: hidden;
}

.bg-decoration {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(5px);
  z-index: 0;
}

.bg-circle-1 { width: 600px; height: 600px; top: -200px; left: -200px; }
.bg-circle-2 { width: 400px; height: 400px; bottom: -150px; right: -150px; }
.bg-circle-3 { width: 200px; height: 200px; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.3; }

.login-card {
  position: relative;
  width: 450px;
  padding: 40px 30px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  z-index: 1;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.logo-icon { font-size: 32px; color: #4361ee; margin-right: 12px; }
.logo-title { font-size: 26px; color: #2d3748; font-weight: 600; letter-spacing: 0.5px; }

.login-form {
  width: 100%;
  gap: 16px;
  display: flex;
  flex-direction: column;
}

.form-input {
  width: 100%;
  height: 52px;
  padding: 0 20px;
  background: rgba(247, 248, 250, 0.8);
  border-radius: 12px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.form-input:focus {
  background: #fff;
  box-shadow: 0 0 0 2px rgba(67, 97, 238, 0.2);
}

.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  font-size: 14px;
}

.remember-checkbox { color: #4a5568; cursor: pointer; }
.forgot-link { color: #4361ee !important; cursor: pointer; }
.forgot-link:hover { color: #3a0ca3 !important; text-decoration: underline; }

.login-btn {
  width: 100%;
  height: 54px;
  font-size: 18px;
  font-weight: 500;
  border-radius: 12px;
  background: linear-gradient(90deg, #4361ee 0%, #3a0ca3 100%);
  border: none;
  transition: all 0.3s ease;
}

.login-btn:hover {
  background: linear-gradient(90deg, #3a56d4 0%, #320b8f 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(67, 97, 238, 0.2);
}

.login-btn:active { transform: translateY(0); }

.copyright {
  margin-top: 30px;
  text-align: center;
  font-size: 13px;
  color: #718096;
  letter-spacing: 0.3px;
}

@media (max-width: 576px) {
  .login-card { width: 90%; padding: 30px 20px; }
  .logo-title { font-size: 22px; }
  .form-input { height: 48px; font-size: 15px; }
  .login-btn { height: 50px; font-size: 16px; }
}
</style>